import {directive as onClickaway} from 'vue-clickaway';
import {mapActions, mapGetters, mapMutations} from 'vuex';
import moment from 'moment'
import {seo} from '@/mixins/seo'

export default {
    name: 'news-detail',
    mixins: [seo],
    directives: {
        onClickaway: onClickaway,
    },
    props: {},
    data() {
        return {
            active: false,
            value: '',
        }
    },
    computed: {
        ...mapGetters({
            currentItem: 'news/currentItem',
            isLoading: 'news/isLoading',
        }),
        formattedDate() {
            return moment(this.currentItem.publishedAt).format('DD MMMM, YYYY')
        },
        formattedTime() {
            return moment(this.currentItem.publishedAt).format('HH:mm')
        }
    },
    created() {
        console.log(this.$route);
    },
    mounted() {
        this.fetchData({slug: this.$route.params.slug}).then(() => {
            Object.assign(this.seo, this.currentItem.seo.data)
            this.$emit('updateHead')
        })
    },
    methods: {
        ...mapActions({
            fetchData: 'news/GET_LIST_ITEM'
        }),
        ...mapMutations({
            setCurrentItem: 'news/SET_ITEM'
        }),
        close() {
            this.active = false;
        },
        setValue(value) {
            this.value = value;
            this.active = false;
        }
    },
    destroyed() {
        this.setCurrentItem(null)
    }
}
